export const required = "Title is required";
export const maxLengthExceeded = "Title maximum length (250 characters) exceeded";
export const nonUnique = "Title should be unique";
